import { Call, Delete, Edit, History, Visibility } from "@material-ui/icons";
import {
  Box,
  IconButton,
  Stack,
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  Tooltip,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { CALL_FLOW_STATUS_OPTIONS, LIST_NETWORK_TYPE } from "constant";
import { formatNumberForVietnamLocale } from "helper/common-helper";
import datetimeHelper from "helper/datetime-helper";
import moment from "moment";

const TableRow = ({ record, columns, actionColumn, showBorder }) => {
  return (
    <MuiTableRow>
      {columns?.map((col) => (
        <MuiTableCell
          align={col.align}
          key={col.id}
          sx={{
            ...(showBorder && { border: "1px solid rgba(224, 224, 224, 1)" }),
          }}>
          {getCellValue(record, col)}
        </MuiTableCell>
      ))}

      {actionColumn && (
        <MuiTableCell align="center">
          <Stack direction="row" spacing={1} justifyContent="center">
            {actionColumn.onEdit && (
              <Tooltip title="Chỉnh sửa dữ liệu">
                <IconButton
                  color={actionColumn.colorButtonEdit}
                  onClick={() => actionColumn.onEdit(record)}
                  sx={{ color: actionColumn.colorButtonEdit ? "" : grey[900] }}>
                  <Edit />
                </IconButton>
              </Tooltip>
            )}
            {actionColumn.onDelete && (
              <Tooltip title="Xóa dữ liệu">
                <IconButton
                  onClick={() => actionColumn.onDelete(record)}
                  sx={{ color: grey[900] }}>
                  <Delete />
                </IconButton>
              </Tooltip>
            )}
            {actionColumn.onView && (
              <Tooltip title="Xem chi tiết">
                <IconButton
                  color={actionColumn.colorButtonView}
                  onClick={() => actionColumn.onView(record)}
                  sx={{
                    color: actionColumn.colorButtonView ? "" : grey[900],
                  }}>
                  <Visibility />
                </IconButton>
              </Tooltip>
            )}
            {actionColumn.onViewHistory && (
              <Tooltip title="Xem lịch sử bản ghi">
                <IconButton
                  color={actionColumn.colorButtonViewHistory}
                  onClick={() => actionColumn.onViewHistory(record)}
                  sx={{
                    color: actionColumn.colorButtonViewHistory ? "" : grey[900],
                  }}>
                  <History />
                </IconButton>
              </Tooltip>
            )}

            {actionColumn.customActions?.(record)}
          </Stack>
        </MuiTableCell>
      )}
    </MuiTableRow>
  );
};

const getCellValue = (record, col) => {
  if (col.render) return col.render(record, col);

  let value;
  if (col.id?.includes(".")) {
    // xử lý nested property
    const propertyPath = col.id.split(".");
    value = record;
    for (const property of propertyPath) {
      value = value[property];
      if (value === undefined || value === null) break;
    }
  } else {
    value = record[col.id];
  }

  if (col.type === "date")
    return value ? moment(value).format("YYYY-MM-DD") : null;
  if (col.type === "network")
    return value
      ? LIST_NETWORK_TYPE.find(
          (item) => item.value === value || item.label === value
        )?.label
      : "_";
  if (col.type === "number")
    return value ? formatNumberForVietnamLocale(value) : 0;

  if (col.type === "percent")
    return value ? `${formatNumberForVietnamLocale(value)}%` : "0%";

  if (col.type === "dateDMY")
    return value ? moment(value).format("DD-MM-YYYY") : null;

  if (col.type === "datetime")
    return value && value !== "_"
      ? moment(value).format("YYYY-MM-DD HH:mm:ss")
      : "_";

  if (col.type === "timeSeconds")
    return value ? datetimeHelper.secondToHHMMSS(value) : "00:00:00";

  if (col.type === "timeMilliseconds")
    return value ? datetimeHelper.msToHHMMSS(value) : "00:00:00";

  if (col.type === "audio") {
    return value ? <audio src={value} controls autoPlay={false} /> : null;
  }
  if (col.type === "listNumber") {
    return value
      ? value.map(
          (number, index) => number + `${index < value.length - 1 ? " - " : ""}`
        )
      : null;
  }

  if (col.type === "phone") {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <Call fontSize="small" />
        <span>{value}</span>
      </Box>
    );
  }

  if (col.type === "status") {
    let foundOption = CALL_FLOW_STATUS_OPTIONS.find(
      (option) => option.value === value
    );
    return foundOption.label;
  }

  return value;
};

export default TableRow;
